import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderMarketPlace from "../../components/shared/headers/HeaderMarketPlace";
import HeaderMobile from "../../components/shared/headers/HeaderMobile";
import FooterMarketPlace2 from "../../components/shared/footers/FooterMarketPlace2";
import axios from "axios";
import config from "../../config";
import { Helmet } from "react-helmet";
import Loader from "../Loader";
import PageContainer from "../../components/layouts/PageContainer";
import BreadCrumb from "../../components/elements/BreadCrumb";
import LightBoxicon from "../category/LightBox";
import NoImg from "../../assets/static/img/w-logo.jpg";

const Clearance = () => {
  const breadCrumb = [
    {
      text: "Home",
      url: "/",
    },
    {
      text: "Clearance",
      url: "/",
    },
  ];

  //Views

  const headers = (
    <>
      <HeaderMarketPlace />
      <HeaderMobile />
    </>
  );
  const footer = <FooterMarketPlace2 />;

  const [isLoading, setLoading] = useState(false);
  const [product_list, setProductList] = useState([]);

  useEffect(() => {
    const urls = [
      `${config.apiUrl}/productDetail/100mm-solid-concrete-block-7nm2-66pp-FeC4l`,
      `${config.apiUrl}/productDetail/2400-x-1200-x-100mm-celotex-or-equiv-pir-board-w9Iqn`,
      `${config.apiUrl}/productDetail/class-b-engineering-brick-smooth-red-perforated-400pp-zaceg`,
      `${config.apiUrl}/productDetail/2400-x-1200-x-125mm-sq-edged-plasterboard-vCrzy`,
      `${config.apiUrl}/productDetail/double-pvc-cover-fascia-white-410mm-x-10mm-x-5m-gd1wO`,
      `${config.apiUrl}/productDetail/sl90-cavity-wall-lintel-2100mm-KxsD8`,
      `${config.apiUrl}/productDetail/tuscan-multi-red-facing-brick-500pp-MqWGQ`,
    ];

    const manualDiscountPrices = [1.29, 22.93, 0.4, 6.55, 13.92, 64.46, 0.53];

    const manualNames = [
      "100mm Concrete Blocks 7N",
      "100mm Celotex or equiv",
      "Class B Engineering Brick",

      "2400 x 1200 x 12.5mm SE Plasterboard",
      "200mm PVC Cover Fascia White 5.0m",
      "2100mm SL90 Steel Lintel",
      "Tuscan Multi Red Facing Brick",
    ];

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const responses = await Promise.all(
          urls.map((url) => fetch(url).then((res) => res.json())),
        );

        setLoading(false);

        const formattedProducts = responses
          .map((res, index) => {
            let productData = null;

            if (Array.isArray(res?.data)) {
              const product = res.data[0];
              productData = {
                id: product?.id,
                title: product?.name,

                originalPrice: product?.main_price || product?.unit_price,
                image:
                  product?.pics?.[0] ||
                  product?.thumbnail_image ||
                  product?.photos?.[0]?.path ||
                  "",
              };
            }

            if (res?.details) {
              const product = res.details;
              productData = {
                id: product?.id,
                title: product?.name,
                originalPrice: product?.main_price || product?.unit_price,
                image:
                  product?.pics?.[0] ||
                  product?.thumbnail_image ||
                  product?.photos?.[0]?.path ||
                  "",
              };
            }

            if (productData) {
              productData.discountPrice = manualDiscountPrices[index];
              productData.subtitle = manualNames[index];
            }

            return productData;
          })
          .filter(Boolean);

        setProductList(formattedProducts);
      } catch (error) {
        setLoading(false);
        console.log("API error:", error);
      }
    };

    fetchProducts();
  }, []);

  function applyDiscount(value, percentage) {
    let discountPercentage = percentage / 100;
    let discountedValue = value - value * discountPercentage;
    discountedValue = parseFloat(discountedValue * 100) / 100;
    return parseFloat(discountedValue)?.toFixed(2);
  }

  const onSortBy = (e) => {
    if (e.target.value == "") {
      setCalled(!isCalled);
      setProductList(product_list);
    } else if (e.target.value == "Newest") {
      setCalled(!isCalled);
      setProductList(product_list.sort((a, b) => b.id - a.id));
    } else if (e.target.value == "Oldest") {
      setCalled(!isCalled);
      setProductList(product_list.sort((a, b) => a.id - b.id));
    } else if (e.target.value == "Low-High") {
      setCalled(!isCalled);

      setProductList(
        product_list.sort(
          (a, b) =>
            applyDiscount(a.price, a.discount) -
            applyDiscount(b.price, b.discount),
        ),
      );
    } else if (e.target.value == "High-Low") {
      setCalled(!isCalled);
      setProductList(
        product_list.sort(
          (a, b) =>
            applyDiscount(b.price, b.discount) -
            applyDiscount(a.price, a.discount),
        ),
      );
    }
  };

  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const [isCalled, setCalled] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(30);
  useEffect(() => {
    setCurrentItems([]);
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(product_list.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(product_list.length / itemsPerPage));
  }, [product_list, isCalled]);

  const targetDivRef = useRef(null);

  const [showPopup, setShowPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Google Maps link for Harrow Depot
  const STORE_MAPS_LINK =
    "https://www.google.com/maps/search/?api=1&query=92-108+Greenford+Road+Harrow+Middlesex+HA1+3QL";

  return (
    <div>
      <Helmet>
        <title>Best Deals on W-Hanson UK Products and Services</title>
        <meta
          name="description"
          content="Don’t miss out on great offers at W-Hanson UK. Save big on a range of products and services for a limited time."
        />
      </Helmet>
      {isLoading && <Loader />}
      <PageContainer header={headers} footer={footer} boxed={true}>
        <div className="ps-page--shop" ref={targetDivRef}>
          <BreadCrumb breacrumb={breadCrumb} />
          <div className="container">
            <div className="ps-layout--shop ps-shop--category">
              <div
                className="ps-layout__right col-12"
                style={{ maxWidth: "100%" }}
              >
                <h3
                  className="ps-shop__heading d-md-flex justify-space-between align-items-center"
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  Clearance Sale
                  <div
                    className=" mx-2 mb-0 text-danger"
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Avaliable on Harrow Depot Only
                  </div>
                </h3>
                <div className="ps-shopping pb-0">
                  <div className="ps-shopping__header">
                    <p>
                      <strong className="mr-2">{product_list?.length}</strong>
                      Products found
                    </p>
                    {/* <div className="ps-shopping__actions">
                      <select
                        className="ps-select form-control ml-10"
                        data-placeholder="Sort Items"
                        onChange={onSortBy}
                      >
                        <option value="">Sort By</option>
                        <option value="Newest">Newest</option>
                        <option value="Oldest">Oldest</option>
                        <option value="Low-High">Price: Low to High</option>
                        <option value="High-Low">Price: High to Low</option>
                      </select>
                    </div> */}
                  </div>
                  <div className="row">
                    {currentItems.map((items, i) => {
                      const stars = [];
                      for (let i = 1; i <= 5; i++) {
                        const className =
                          i <= items.rating ? "fa fa-star" : "fa fa-star-o";
                        stars.push(<i className={className} key={i}></i>);
                      }

                      let maxPrice = 0;
                      let minPrice = 0;
                      if (items?.stock?.length >= 1) {
                        minPrice = parseFloat(items?.stock[0]?.price).toFixed(
                          2,
                        );
                        maxPrice = parseFloat(items?.stock[0]?.price).toFixed(
                          2,
                        );
                      }

                      let Price;
                      if (items?.stock?.length == 1) {
                        Price =
                          "£" + parseFloat(items?.stock[0]?.price).toFixed(2);
                      } else {
                        items?.stock?.forEach((item) => {
                          const price = parseFloat(item.price).toFixed(2);
                          if (price < minPrice) {
                            minPrice = price;
                          }
                          if (price > maxPrice) {
                            maxPrice = price;
                          }
                        });
                        Price = "£" + minPrice + " - " + "£" + maxPrice;
                      }

                      const mainArray =
                        items.lengths != null && items.lengths != "null"
                          ? JSON.parse(items.lengths)
                          : [];
                      const containsStatus1 = mainArray?.some(
                        (item) => item.status === 1,
                      );

                      return (
                        <div
                          key={i}
                          className="col-md-3 pl-0 pr-0 big-resp mb-5"
                          onClick={() => {
                            // ← add this
                            setSelectedProduct(items);
                            setShowPopup(true);
                          }}
                        >
                          <div
                            className={
                              items.name?.length > 130
                                ? "ps-product ps-product--inner all-product-card h-280"
                                : "ps-product ps-product--inner all-product-card h-280"
                            }
                          >
                            <div className="ps-product__thumbnail text-center">
                              {items.image != null ? (
                                <img
                                  src={items.image}
                                  loading="lazy"
                                  alt="No img"
                                  height="171"
                                  style={{
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    height: "171px",
                                  }}
                                >
                                  <img
                                    src={NoImg}
                                    loading="lazy"
                                    alt="No img"
                                    height="200"
                                    className="mt-15"
                                  />
                                </div>
                              )}

                              <LightBoxicon productId={items.id} />
                            </div>
                            <div className="ps-product__container">
                              <Link
                                to={`/product/${items.slug}`}
                                className="ps-product__vendor"
                                href="/shop"
                              >
                                {items?.subtitle}
                              </Link>
                              {/* <div className="ps-product__rating text-center ">
                                <span className="ps-rating">{stars}</span>
                              </div> */}
                              {/* <div className="ps-product__content"> */}
                              <div className="text-center">
                                <p
                                  className="ps-product__price sale"
                                  style={{
                                    fontSize: "16px",
                                  }}
                                >
                                  <span
                                    className="text-black"
                                    style={{
                                      color: "black",
                                    }}
                                  >
                                    {" "}
                                    Price Range :
                                  </span>{" "}
                                  <br />
                                  {/* {Price} */}
                                  <s
                                    style={{
                                      paddingRight: "20px",
                                      textDecoration: "strike-out",
                                    }}
                                  >
                                    {items?.originalPrice.toFixed(2)}
                                  </s>
                                  {`£ ${items?.discountPrice?.toFixed(2)}`}
                                  <span
                                    style={{
                                      color: "black",
                                      marginLeft : "5px"
                                    }}
                                  >
                                    + VAT
                                  </span>
                                </p>
                              </div>
                              {/* </div> */}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
      {/* ── Visit Store Popup ── */}
      {showPopup && selectedProduct && (
        <div
          onClick={() => setShowPopup(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: "20px",
              padding: "36px 32px",
              maxWidth: "440px",
              width: "100%",
              textAlign: "center",
              boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
              position: "relative",
            }}
          >
            {/* Close button */}
            <button
              onClick={() => setShowPopup(false)}
              style={{
                position: "absolute",
                top: "14px",
                right: "16px",
                background: "none",
                border: "none",
                fontSize: "22px",
                cursor: "pointer",
                color: "#666",
                lineHeight: 1,
              }}
            >
              ×
            </button>

            {/* Store icon */}
            <div
              style={{
                width: "64px",
                height: "64px",
                background: "#fff3cd",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "28px",
              }}
            >
              🏪
            </div>

            {/* Product name */}
            <p style={{ color: "#888", fontSize: "13px", marginBottom: "4px" }}>
              Clearance Offer
            </p>
            <h5
              style={{
                fontWeight: 700,
                color: "#1a1a2e",
                fontSize: "17px",
                marginBottom: "8px",
              }}
            >
              {selectedProduct.subtitle || selectedProduct.title}
            </h5>

            {/* Price */}
            <div style={{ marginBottom: "20px" }}>
              <s
                style={{ color: "#aaa", fontSize: "14px", marginRight: "8px" }}
              >
                £{Number(selectedProduct.originalPrice).toFixed(2)}
              </s>
              <span
                style={{
                  color: "#e53e3e",
                  fontWeight: 800,
                  fontSize: "22px",
                }}
              >
                £{Number(selectedProduct.discountPrice).toFixed(2)}
              </span>
            </div>

            {/* Message */}
            <div
              style={{
                background: "#fff8e1",
                border: "1px solid #fde68a",
                borderRadius: "12px",
                padding: "14px 16px",
                marginBottom: "24px",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontWeight: 600,
                  color: "#92400e",
                  fontSize: "14px",
                  lineHeight: 1.5,
                }}
              >
                🎉 Visit our <strong>Harrow Store</strong> to claim this offer.
                <br />
                <span style={{ fontWeight: 400, fontSize: "13px" }}>
                  This deal is available exclusively at our Harrow store.
                </span>
              </p>
            </div>

            {/* Google Maps button */}
            <a
              href={STORE_MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                background: "#4285F4",
                color: "#fff",
                borderRadius: "12px",
                padding: "13px 20px",
                fontWeight: 700,
                fontSize: "15px",
                textDecoration: "none",
                marginBottom: "12px",
                transition: "opacity 0.2s",
              }}
            >
              <img
                src="https://maps.gstatic.com/mapfiles/api-3/images/google_white5.png"
                alt="Google Maps"
                style={{ height: "18px" }}
              />
              Get Directions — Harrow Depot
            </a>

            <button
              onClick={() => setShowPopup(false)}
              style={{
                background: "none",
                border: "1px solid #e2e8f0",
                borderRadius: "10px",
                padding: "10px 20px",
                width: "100%",
                cursor: "pointer",
                color: "#64748b",
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clearance;
